import { Component, OnInit, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: './background.component.html',
})
export class BackgroundComponent implements OnInit {
  ngOnInit() {}
}
